import { createSelector } from "reselect";
import { initialState } from "./reducers";
import { isEqual } from "lodash";

export const selectCommunity = ({ community = initialState }) => community;

export const selectCommunityData = ({ community: { community = initialState.community } }) => community;

export const selectCommunityObject = createSelector([selectCommunity], ({ community }) => community);

export const selectCommunityToCompare = createSelector(
    [selectCommunity],
    ({ communityToCompare }) => communityToCompare
);

export const selectIsCommDataChanged = createSelector(
    [selectCommunity],
    ({ community = {}, communityToCompare = {} }) => !isEqual(community, communityToCompare)
);

export const selectCommunityId = createSelector([selectCommunity], ({ communityId }) => communityId);

export const selectCommunityDetails = createSelector([selectCommunityData], ({ communityDetails }) => communityDetails);

export const selectCommunitySettings = createSelector(
    [selectCommunityData],
    ({ communityDetails: { uiSettings = {} } }) => uiSettings
);

export const selectCommunityLocation = createSelector(
    [selectCommunityData],
    ({ communityDetails: { weatherLocation = {} } }) => weatherLocation
);
export const selectCommunityModelDir = createSelector([selectCommunityData], ({ modelDir }) => modelDir);

// export const selectCommunityModelIds = createSelector(
//     [selectCommunityData],
//     ({ modelDir }) => Object.keys(modelDir.models)
// )

export const selectCommunityModelData = createSelector([selectCommunityData], ({ modelData }) => modelData);

export const selectCommunityEcmInputMap = createSelector([selectCommunityData], ({ ecmInputMap }) => ecmInputMap);

export const selectCommunityIsSavingEcmInputMap = createSelector(
    [selectCommunity],
    ({ isSavingEcmInputMap }) => isSavingEcmInputMap
);

export const selectCommunityIsSaving = createSelector(
    [selectCommunity],
    ({ isSavingCommunity }) => isSavingCommunity
);

export const selectCommunityLoading = createSelector([selectCommunity], ({ loading }) => loading);

export const selectCommunityError = createSelector([selectCommunity], ({ error }) => error);

export const selectCommunityRunHistory = createSelector(
    [selectCommunityData],
    ({ communityDetails: { runHistory = {} } }) => runHistory
);

export const selectCommunityLastValidationRun = createSelector([selectCommunityDetails], (details) => {
    if (!details) return {};
    return details.lastValidationRun || {};
});

export const selectUpgradePackagesInRun = createSelector(
    [selectCommunityData],
    ({ communityDetails: { upgradePackagesRun = {} } = {} }) => upgradePackagesRun
);

export const selectModelsInRun = createSelector(
    [selectCommunityData],
    ({ communityDetails: { modelsRun = {} } = {} }) => modelsRun
);

export const selectModelUpgradesRun = createSelector(
    [selectCommunityData],
    ({ communityDetails: { modelUpgradesRun = {} } = {} }) => modelUpgradesRun
);

export const selectFuelCosts = createSelector(
    [selectCommunityData],
    ({ configuration: { fuelCosts = {} } = {} }) => fuelCosts
);

// export const communitySelector = (path) => createSelector(
//     [selectCommunity],
//     (community) => !path ? "" : resolveObj(path, community)
// );

// export const resolveObj = (path, obj) => {
//     return path.split(".").reduce((cache, curr) => {
//         return cache ? cache[curr] : null;
//     }, obj);
// };
